<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :id="slug"
             :fields="fields"
             :items="items"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
    >
        <template v-slot:cell(paystub)="row">
            <div v-if="hasAttachment(row, 'PS')">
                <b-button size="sm"
                          variant="primary"
                          class="mr-1"
                          @click="downloadPaystub(row)"
                          target="_attach"
                >
                    Download
                </b-button>
            </div>
            <div v-else>N/A</div>
        </template>
        <template v-slot:cell(jobdescription)="row">
            <div v-if="hasAttachment(row, 'JD')">
                <b-button size="sm"
                          variant="primary"
                          class="mr-1"
                          @click="downloadJobDescription(row)"
                          target="_attach"
                >
                    Download
                </b-button>
            </div>
            <div v-else>N/A</div>
        </template>
        <template v-slot:cell(startDate)="row">
            {{formatDate(row.item.startDate)}}
        </template>
        <template v-slot:cell(endDate)="row">
            {{formatDate(row.item.endDate)}}
        </template>
        <template v-slot:empty="scope">
            <p>No employers listed.</p>
        </template>

        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';
    export default {
        name: "EmployerList",
        components:{},
        props:{
            items: Array,
            slug:[String],
            isLoading: Boolean,
        },
        data:()=>({
            fields:[
                {key:'name',label:'Name',sortable:true},
                {key:'address.streetAddress',label:'Address',sortable: true},
                {key:'address.city',label:'City',sortable:true},
                {key:'address.state',label:'State',sortable:true},
                {key:'address.postalCode',label: 'Zip Code',sortable:true},
                {key:'department',label:'Department',sortable:true},
                {key:'startDate',label:'Start Date',sortable:true},
                {key:'endDate',label:'End Date',sortable:true},
                {key:'paystub',label:'Pay stub'},
                {key:'jobDescription',label:'Job Description'}
            ]
        }),
        methods:{
            hasAttachment(row, type) {
                return row.item.attachments.filter(s => s.type.code === type).length > 0
            },
            downloadPaystub(row){
                let id = row.item.attachments.filter(s => s.type.code === "PS")[0].attachmentId;
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+id)
                    .then(response=>{
                        window.open(response.data,"_blank");
                    })
            },
            downloadJobDescription(row){
                let id = row.item.attachments.filter(s => s.type.code === "JD")[0].attachmentId;
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+id)
                    .then(response=>{
                        window.open(response.data,"_blank");
                    })
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            }
        }
    }
</script>

<style scoped>

</style>

